import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;
  color: ${themeGet('colors.text.success')};
  text-decoration: none;
`
